import { FONT_SIZE_BASE } from './constants';
export const fontSizes = [
    `${1 - 3 / FONT_SIZE_BASE}rem`,
    `${1 - 1 / FONT_SIZE_BASE}rem`,
    `${1 + 1 / FONT_SIZE_BASE}rem`,
    `${1 + 3 / FONT_SIZE_BASE}rem`,
    `${1 + 5 / FONT_SIZE_BASE}rem`,
    `${1 + 7 / FONT_SIZE_BASE}rem`,
    `${1 + 9 / FONT_SIZE_BASE}rem`,
    `${1 + 11 / FONT_SIZE_BASE}rem`,
    `${1 + 17 / FONT_SIZE_BASE}rem`,
    `${1 + 19 / FONT_SIZE_BASE}rem`,
    `${1 + 35 / FONT_SIZE_BASE}rem`,
];
//# sourceMappingURL=fontSizes.js.map